import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';

import { BaseLabel } from '../../../../styled/labels/labels';
import { COLOR_1, COLOR_2, COLOR_BORDER } from '../../../../styled/variables/variables';

const SingleBarChart = ({ value }) => {

  return (
 
    <Wrapper>
      <ValueBar proportion={ value / 100 }>
        <Percentage>
          { value }%
        </Percentage>
      </ValueBar>
      <RemainingBar proportion={ 1 - (value / 100) } />
    </Wrapper>
  );
};

SingleBarChart.defaultProps = {
	value: 75,
};
SingleBarChart.propTypes = {
	value: propTypes.any
};
const Wrapper = styled.div`
	display: flex;
	height: 25px;
	margin-bottom: 10px;
	border-radius: 1px;
	overflow: hidden;
`;

const ValueBar = styled.div`
	height: 100%;
	flex-grow: ${ ({ proportion }) => proportion };
	align-self: center;
	background-color: ${ COLOR_1 };
	justify-content: flex-end;
	display: flex;
	/* padding: 0 5px; */
	border: 1px solid ${ COLOR_BORDER };
`;

const Percentage = styled(BaseLabel)`
	color: ${ COLOR_2 };
	opacity: 0.8;
	font-size: 14px;
	align-self: center;
	padding: 0 5px;
`;

const RemainingBar = styled(ValueBar)`
	opacity: .7;
	background-color: ${ COLOR_2 };
	border: 1px solid ${ COLOR_BORDER };
	border-left-width: 0px;
`;

export default SingleBarChart;
